var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStableDiffusionApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 113,
    viewBox: "0 0 135 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 57.1725V50.8479C0 48.7447 0.113718 46.6385 0.610355 44.5949C4.36822 29.1311 20.7691 2.43063 60 0.188865C98.3434 -2.00219 119.045 15.3652 126.291 26.6489C127.548 28.6074 128.717 30.618 129.782 32.6876C135.608 44.013 139.717 68.2233 122.408 90.2925C120.864 92.2607 119.016 93.9732 117.112 95.5962L117.053 95.6465C111.522 100.363 106.39 104.739 86.5201 110.667C84.1928 111.361 81.7876 111.834 79.3654 112.011C78.0776 112.105 76.6613 112.184 75.5 112.189C73.5257 112.197 70.5882 111.968 68.8763 111.817C67.9573 111.736 67.0357 111.643 66.1536 111.373C60.7509 109.717 56.2348 103.401 53 87.6889C52 82.8317 48 76.1889 41 76.1889C38.6901 76.1889 36.3889 76.5416 33.8888 76.9249C32.0595 77.2053 30.1237 77.502 28 77.6889C25.2138 77.934 21.8547 77.9191 19.075 77.8372C16.6941 77.767 14.2998 77.5237 12.0602 76.7124C8.64567 75.4755 4.64297 73.075 1.93976 67.8454C0.257962 64.5917 0 60.8351 0 57.1725ZM22.5 63.1889C26.9183 63.1889 30.5 59.831 30.5 55.6889C30.5 51.5467 26.9183 48.1889 22.5 48.1889C18.0817 48.1889 14.5 51.5467 14.5 55.6889C14.5 59.831 18.0817 63.1889 22.5 63.1889Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 99.1889C123.702 88.4654 131.167 70.6889 134.5 61.1889C129.557 96.7787 103.112 105.98 88.5005 110.533C88.1613 110.639 87.8294 110.736 87.4857 110.826C86.3046 111.134 83.3211 111.881 81 112.189C79.5285 112.384 77.5772 112.504 75.8678 112.578C73.297 112.689 70.7281 112.434 68.2049 111.93L67.4098 111.771C65.4885 111.387 63.6107 110.678 62.2243 109.293C58.7069 105.781 55.8272 100.187 55 96.1889C59 103.789 67.7732 104.189 71.5 104.189C77 104.189 80.5 105.189 96 99.1889Z",
    fill: "#E2E5EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34932 62.6507C1.77086 60.7267 0.568936 58.706 0 57.1889V57.8726C0 60.4072 0.310848 62.9323 0.925582 65.3912L1 65.6889C3 70.6889 7.67502 78.1889 20.5 78.1889C30.4299 78.1889 33.0667 77.022 37.3235 76.4708C40.4032 76.0721 43.6092 76.493 46.2811 78.0756C52.8193 81.9484 52.5769 87.612 53 87.1889C53.4 86.7889 53.5 84.8555 53.5 83.6889C53 77.0222 49.5 64.3889 39.5 67.1889C34.6557 68.5453 29.3813 69.096 24.6997 69.2275C16.8951 69.4467 8.30148 68.6868 3.34932 62.6507Z",
    fill: "#E2E6E7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41,
    cy: 29.1889,
    rx: 10.5,
    ry: 10,
    fill: "#A4D668"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67,
    cy: 18.1889,
    rx: 10.5,
    ry: 10,
    fill: "#FE6C5E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93,
    cy: 27.1889,
    rx: 10.5,
    ry: 10,
    fill: "#62A2F2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104,
    cy: 52.1889,
    rx: 10.5,
    ry: 10,
    fill: "#B1B7C5"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96,
    cy: 78.1889,
    rx: 10.5,
    ry: 10,
    fill: "#FCCF5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStableDiffusionApp);
export default __webpack_public_path__ + "static/media/stable-diffusion-app.44125cc68399fbd6689f53370b1110ed.svg";
export { ForwardRef as ReactComponent };